import dayjs from 'dayjs';

export default dayjs;
